import { PageLoansDisbursementCreate } from './Create';
import { PageLoansDisbursementEdit } from './Edit';
import { PageLoansDisbursementOverview } from './Overview';

export const DISBURSEMENTS = {
  LoansDisbursementEdit: PageLoansDisbursementEdit,
  LoansDisbursementCreate: PageLoansDisbursementCreate,
  LoansDisbursementOverview: PageLoansDisbursementOverview,
} as const;
